import {CreativeTemplateFeature} from 'common/src/modules/creativeTemplates/creativeTemplates.types';

const FALLBACK_RESTRICTED_FEATURES: CreativeTemplateFeature[] = [
  CreativeTemplateFeature.Feed,
  CreativeTemplateFeature.Location,
  CreativeTemplateFeature.Content,
  CreativeTemplateFeature.Weather,
];

const FEATURE_LABELS: Record<CreativeTemplateFeature, string> = {
  [CreativeTemplateFeature.Feed]: 'products',
  [CreativeTemplateFeature.Location]: 'location/store',
  [CreativeTemplateFeature.Content]: 'content',
  [CreativeTemplateFeature.Weather]: 'weather',
  [CreativeTemplateFeature.Xenon]: 'xenon',
  [CreativeTemplateFeature.PromoSlide]: 'promoSlide',
  [CreativeTemplateFeature.Video]: 'video',
};

export type ValidateCreativeToBeUsedAsFallbackCreativeResult =
  | {isValid: true}
  | {isValid: false; errorMessage: string};

function validateCreativeToBeUsedAsFallbackCreative(creative: {
  name: string;
  id: number;
  features?: CreativeTemplateFeature[];
}): ValidateCreativeToBeUsedAsFallbackCreativeResult {
  const features = creative.features ?? [];

  const restrictedFound = FALLBACK_RESTRICTED_FEATURES.filter((feature) =>
    features.includes(feature),
  );

  if (restrictedFound.length === 0) {
    return {isValid: true};
  }

  const featureLabels = restrictedFound.map((f) => FEATURE_LABELS[f] ?? f).join(', ');

  return {
    isValid: false,
    errorMessage: `Creative "${creative.name}" (ID: ${creative.id}) cannot be used as a fallback creative because it supports ${featureLabels}, which require data from other cards. Fallback creatives must not support products, location, content, or weather.`,
  };
}

export default validateCreativeToBeUsedAsFallbackCreative;
export {FALLBACK_RESTRICTED_FEATURES};
